<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label for="">Cantidad</label>
                        <input type="number" class="form-control" v-model="PaquetePropiedadBase.Cantidad">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="errorvalidacion.Cantidad" :Mensaje="errorvalidacion.Cantidad[0]"></Cvalidation></label>
                    </div>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
export default {
    name:'Form',
    props:['poBtnSave'],
    data() {
        return {
            Modal:true,
            Name:'PropiedadForm',
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            PaquetePropiedadBase:{
                IdPaquetePropiedadBase:0,
                Cantidad:0
            },
            errorvalidacion:[]
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.disableBtn=true;
            let formData=new FormData();
            formData.set('IdPaquetePropiedadBase',this.PaquetePropiedadBase.IdPaquetePropiedadBase);
            formData.set('Cantidad',this.PaquetePropiedadBase.Cantidad);
            await this.$http.post('paquetepropiedadbase/post',formData
            ).then((res)=>{
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#ModalForm').modal('hide');
                this.bus.$emit('List');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            })
        },
        Limpiar(){
            this.PaquetePropiedadBase={
                IdPaquetePropiedadBase:0,
                Cantidad:0
            },
            this.errorvalidacion=[];
        },
        get_one(){
            this.$http.get('paquetepropiedadbase/recovery',{
                params:{
                    IdPaquetePropiedadBase:this.PaquetePropiedadBase.IdPaquetePropiedadBase
                }
            }).then((res)=>{
                this.PaquetePropiedadBase.IdPaquetePropiedadBase=res.data.data.PaquetePropiedadBase.IdPaquetePropiedadBase;
                this.PaquetePropiedadBase.Cantidad=res.data.data.PaquetePropiedadBase.Cantidad;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        }
    },
    created() {
        this.bus.$off('Nuevo');
        this.bus.$on('Nuevo',(data,Id)=> 
        {
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=false; 
            this.bus.$off('Save');

            this.bus.$on('Save',()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            if (Id>0) 
            {
                this.PaquetePropiedadBase.IdPaquetePropiedadBase=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
        });
        if (this.Id!=undefined)
        {
            this.PaquetePropiedadBase.IdPaquetePropiedadBase=this.Id;
            this.get_one();
        }
    }
}
</script>

<style>

</style>